module.exports = __webpack_public_path__ + "media/images/member_coupon-9854760db42862679dec027f3ae5aa54.svg";